import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceCard = ({ title, value, change, changeType, icon, iconColor }) => {
  const isPositive = changeType === 'positive';
  const isNegative = changeType === 'negative';
  
  return (
    <div className="card-elevated transition-smooth hover:shadow-lg">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm font-interface text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            {value}
          </h3>
        </div>
        <div 
          className="w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: iconColor === '#9B8DC7' ? 'rgba(155, 141, 199, 0.15)' : `${iconColor}15` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>
      
      {change && (
        <div className="flex items-center gap-2">
          <Icon 
            name={isPositive ? 'TrendingUp' : isNegative ? 'TrendingDown' : 'Minus'} 
            size={16} 
            color={isPositive ? 'var(--color-success)' : isNegative ? 'var(--color-error)' : 'var(--color-muted-foreground)'} 
          />
          <span 
            className={`text-sm font-interface font-medium ${
              isPositive ? 'text-success' : isNegative ? 'text-error' : 'text-muted-foreground'
            }`}
          >
            {change}
          </span>
          <span className="text-sm font-interface text-muted-foreground">vs last period</span>
        </div>
      )}
    </div>
  );
};

export default PerformanceCard;